<button (click)="back()">
  <mat-icon svgIcon="back_icon" class="back-icon" />
  <span>{{ 'shared.back' | translate }}</span>
</button>
